module.exports = __webpack_public_path__ + "img/banner-bottom@2x.048b97b5.jpg";